import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'
import { service } from '@ember/service'
import type RouterService from '@ember/routing/router-service'
import { ShareStatus } from 'teacher-ui-client/models/book-library/share'

export default class BookLibrarySharesByCollectionController extends Controller {
  @service router!: RouterService

  queryParams = ['page', 'size', 'sort', 'status']

  @tracked page = 1

  @tracked size = 10

  @tracked sort = 'collection.name'

  @tracked status = [ShareStatus.Pending, ShareStatus.Active]

  // We do this in the controller, rather than the route model, so that when it updates, it is tracked
  get expandedShareId(): string | undefined {
    const shareId = this.router.currentRoute?.params?.share_id
    if (typeof shareId === 'string') return shareId
  }
}

declare module '@ember/controller' {
  interface Registry {
    'subscription-type/book-library/shares/index/by-collection': BookLibrarySharesByCollectionController
  }
}
